export default __webpack_public_path__ + "static/media/NS1.1e793345.svg";